import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Modal} from "../../../../components/modal/modal.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import Button from "../../../../components/button/button.jsx";
import moment from "moment";
import integrationSharedImageCellRenderer from "./integration-shared-image-cell-renderer.jsx";
import Swal from "sweetalert2";
import integrationsService from "../../../../services/web/integrations-service.js";
import projectUtils from "../../../../utils/project-utils.js";
import withReactContent from "sweetalert2-react-content";
import {toast} from "react-toastify";

const MySwal = withReactContent(Swal);

const IntegrationSharedImage = ({open, setOpen, data, refetchImage, refetch, dataFetch}) => {
    const [updatedData, setUpdatedData] = useState({rowData: undefined, api: undefined})

    useEffect(() => {
        if (!updatedData.rowData) return;

        const {rowData, api} = updatedData;

        integrationsService.imageRequestPost(rowData)
            .then(() => {
                const rowNode = api.getRowNode(rowData.code);
                rowNode.setDataValue('status', rowData.status);

                refetchImage();

                if (rowData.code === "sspsp" && !rowData.status) {
                    const sspsp = dataFetch.lanes
                        .filter(lane => lane[rowData.name]?.status !== "ND")
                        .map(lane => ({laneCode: lane.code, type: rowData.name, status: { status: false }}));

                    integrationsService.updateStatus(sspsp)
                        .then(() => {
                            refetch();
                            toast.success("Salvo com sucesso");
                        })
                        .catch(error => {
                            console.error(error);
                            let message = "Não foi possível salvar.";
                            if (error.response.status !== 500) {
                                message = error.response.data.message;
                            }

                            projectUtils.swalErrorMessage('', message, 'Ok');
                        });
                }
            })
            .catch((error) => {
                console.error(error);
                projectUtils.swalErrorMessage("", "Não foi possível alterar o status.", "Ok");
            });

        setUpdatedData({rowData: undefined, api: undefined});
    }, [updatedData.rowData]);

    const onChangeStatus = (checked, rowData, api) => {
        let html = `Para ${!checked ? "desativar" : "ativar"}, digite <span class="font-bold">Confirmar</span> abaixo:`;
        let confirmText = "Confirmar";

        if (rowData.code === "sspsp" && !checked) {
            html = `
                Atenção. Desativar o compartilhamento de imagens irá <b>INATIVAR</b> toda a integração com a <b>Muralha Paulista</b>. 
                <br />
                Para confirmar, digite <span class="font-bold">Inativar a integração</span> abaixo:
            `;
            confirmText = "Inativar a integração";
        }

        MySwal.fire({
            icon: "warning",
            type: "warning",
            title: "Alterar compartilhamento de imagem",
            html,
            confirmButtonColor: '#063A6C',
            confirmButtonText: "Continuar",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            cancelButtonColor: '#ed5565',
            reverseButtons: true,
            input: "text",
            preConfirm(inputValue) {
                if (inputValue.trim() !== confirmText) {
                    Swal.showValidationMessage(`Digite corretamente a palavra-chave`);
                }
            }
        }).then(({isConfirmed}) => {
            if (isConfirmed) {
                setTimeout(() => {
                    const newItem = {...rowData, status: checked};
                    setUpdatedData({rowData: newItem, api});
                }, 100)
            }
        });
    }

    const [columnDefs,] = useState([
        {field: "name", headerName: "Convênio", flex: 2},
        {
            field: "status",
            headerName: "Status",
            sort: "asc", width: 100,
            cellRenderer: integrationSharedImageCellRenderer,
            cellRendererParams: {onChangeStatus}
        },
        {field: "userLastUpdate", headerName: "Usuário", flex: 1},
        {field: "lastUpdate", headerName: "Data/hora", flex: 1, valueFormatter: ({value}) => value ? moment(value).format('DD/MM/YYYY HH:mm') : ""},
    ]);

    const gridRef = useRef(undefined);
    const defaultColDef = useMemo(() => ({resizable: false}), []);

    const theme = useMemo(() => {
        return aggridUtils.generalTheme();
    }, []);

    return (
        <Modal open={open} setOpen={setOpen} title={"Compartilhamento de imagem"} overflow={true}>
            <Modal.Body className={"!mt-0 p-4"}>
                <div className={"aggrid-row-pointer"} style={{height: "calc(100vh - 245px)"}}>
                    <AgGridReact
                        ref={gridRef}
                        rowHeight={35}
                        rowData={data}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        paginationAutoPageSize={true}
                        pagination={true}
                        animateRows={false}
                        suppressCellFocus={true}
                        gridOptions={{localeText: aggridUtils.localization()}}
                        getRowId={({ data }) => data.code}
                        theme={theme}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => setOpen(false)}>
                    Ok
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default IntegrationSharedImage;